import { PageTitle } from '../layouts/PageTitle';

const CompanyOverview = () => {
  return (
    <section className="pb-12">
      <PageTitle title="会社概要" />
      <table className="max-w-[540px] mx-auto w-[90%]">
        <tbody className="text-left">
          <tr className="text-[14px] leading-[32px] border-2 border-gray-400">
            <th scope="row" className="border-r-2 border-gray-400 pl-4 w-[28vw] max-w-[120px]">
              <span>会社名</span>
            </th>
            <td className="pl-4">
              <span>株式会社ALBONA</span>
            </td>
          </tr>
          <tr className="text-[14px] leading-[32px] border-2 border-gray-400">
            <th scope="row" className="border-r-2 border-gray-400 pl-4 w-[28vw] max-w-[120px]">
              <span>設立</span>
            </th>
            <td className="pl-4">
              <span>2020年5月</span>
            </td>
          </tr>
          <tr className="text-[14px] leading-[32px] border-2 border-gray-400">
            <th scope="row" className="border-r-2 border-gray-400 pl-4 w-[28vw] max-w-[120px]">
              <span>代表</span>
            </th>
            <td className="pl-4">
              <span>野下滉貴</span>
            </td>
          </tr>
          <tr className="text-[14px] leading-[32px] border-2 border-gray-400">
            <th scope="row" className="border-r-2 border-gray-400 pl-4 w-[28vw] max-w-[120px]">
              <span>資本金</span>
            </th>
            <td className="pl-4">
              <span>1,000,000円</span>
            </td>
          </tr>
          <tr className="text-[14px] leading-[32px] border-2 border-gray-400">
            <th scope="row" className="border-r-2 border-gray-400 pl-4 w-[28vw] max-w-[120px]">
              <span>所在地</span>
            </th>
            <td className="pl-4">
              <ul>
                <li>・東京都渋谷区道玄坂1-20-8 寿パークビル4F</li>
                <li>・福岡県福岡市中央区大名1-4-1 NDビル 5F</li>
              </ul>
            </td>
          </tr>
          <tr className="text-[14px] leading-[32px] border-2 border-gray-400">
            <th scope="row" className="border-r-2 border-gray-400 pl-4 w-[28vw] max-w-[120px]">
              <span>従業員数</span>
            </th>
            <td className="pl-4">
              <span>60名(アルバイト業務委託含む)</span>
            </td>
          </tr>
          <tr className="text-[14px] leading-[32px] border-2 border-gray-400">
            <th scope="row" className="border-r-2 border-gray-400 pl-4 w-[28vw] max-w-[120px]">
              <span>主要取引銀行</span>
            </th>
            <td className="pl-4">
              <ul>
                <li>みずほ銀行 恵比寿支店</li>
                <li>城北信用金庫 渋谷支店</li>
              </ul>
            </td>
          </tr>
          <tr className="text-[14px] leading-[32px] border-2 border-gray-400">
            <th scope="row" className="border-r-2 border-gray-400 pl-4 w-[28vw] max-w-[120px]">
              <span>事業内容</span>
            </th>
            <td className="pl-4">
              <ul>
                <li>・D2Cクライアント向けのデジタルマーケティング支援</li>
                <li>・レガシー領域のDX化に対応するクライアント向けデジタルマーケティング支援</li>
                <li>・C向け/B向けサービスの新規事業運営及び開発</li>
                <li>・有料人材紹介事業</li>
              </ul>
            </td>
          </tr>
          <tr className="text-[14px] leading-[32px] border-2 border-gray-400">
            <th scope="row" className="border-r-2 border-gray-400 pl-4 w-[28vw] max-w-[120px]">
              <span>許可番号</span>
            </th>
            <td className="pl-4">
              <span>厚生労働大臣許可番号 12-ユ-315663</span>
            </td>
          </tr>
          <tr className="text-[14px] leading-[32px] border-2 border-gray-400">
            <th scope="row" className="border-r-2 border-gray-400 pl-4 w-[28vw] max-w-[120px]">
              <span>HP</span>
            </th>
            <td className="pl-4">
              <a
                className="border-b-2 border-blue-600 text-blue-600"
                href="https://al-bo.io/"
                target="_blank"
                rel="noreferrer"
              >
                https://al-bo.io/
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  );
};

export { CompanyOverview };
